import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatOption, MatSelect } from "@angular/material/select";
import { UserService } from "../../../../_services";
import { NgIf } from "@angular/common";

@Component({
  selector: 'hawk-set-technician-state',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatSelect,
    MatOption,
    MatLabel,
    NgIf
  ],
  templateUrl: './set-technician-state.component.html',
  styleUrls: ['./set-technician-state.component.scss', './../../styles/common_styles.scss', './../../../_shared/styles/common-styles.scss']
})
export class SetTechnicianStateComponent implements OnChanges {

  formGroup: UntypedFormGroup

  @Input() technician: {
    id: number,
    firstname: string,
    lastname: string,
    state: string
  };

  @Output() closeComponent: EventEmitter<void> = new EventEmitter();

  constructor(
    private userService: UserService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initFormGroup()
  }

  initFormGroup() {
    this.formGroup = new UntypedFormGroup({
      state: new UntypedFormControl('', [Validators.required]),
    })

    this.formGroup.controls['state'].setValue(this.technician?.state || '')
  }

  onSubmit() {
    if (this.formGroup.valid) {
      this.userService.updateUser(this.technician.id, { address_state: this.formGroup.controls['state'].value }).subscribe(
        data => {
          this.technician.state = data.state
          this.closeComponent.emit();
        },
        error => {
          console.log(error)
        }
      )
    }
  }
}
